<div class="row" *ngIf="availableItems">
  <div class="col-md-6">
    <search-box
      #box
      placeHolder="Search ..."
      [searchCriteria]="searchCriteria"
      (searchCriteriaChanged)="updateSearchCriteria($event)"
      [options]="{ showFilterBtn: false}"
    >
    </search-box>
    <div class="list-group">
      <a
        class="list-group-item"
        *ngFor="let item of availableItems"
        (click)="addHandler(item)"
        [class.disabled]="isSelected(item)"
      >
        {{ item }}
      </a>
    </div>
    <pager
      [items]="availableItems.paging"
      (pageChanged)="pageChanged($event)"
      [options]="{ showPagingSummary:false, size: 2, shouldShowFirstPageLink: false, shouldShowLastPageLink: false}"
    ></pager>
  </div>
  <div class="col-md-6">
    <div class="list-group">
      <a class="list-group-item active">Selected</a>
      <a
        class="list-group-item"
        *ngFor="let selectedItem of items"
        (click)="selectedItemClickHandler(selectedItem)"
      >
        {{ selectedItem }}
        <button type="button" class="close" (click)="removeHandler(selectedItem)">
          <span aria-hidden="true">&times;</span
          ><span class="sr-only"><mat-icon>close</mat-icon></span>
        </button>
      </a>
    </div>
  </div>
</div>
